import React from "react";
import { Search } from "lucide-react";

export function SearchBar({ value, onChange, placeholder = "Search" }) {
  return (
    <div className="search-bar">
      <div className="search-wrapper">
        <Search className="search-icon" />
        <input
          type="search"
          placeholder={placeholder}
          className="search-input"
          value={value}
          onChange={onChange}
        />
      </div>

      <style jsx>{`
        .search-bar {
          width: 100%;
        }

        .search-wrapper {
          position: relative;
          width: 100%;
        }

        .search-icon {
          position: absolute;
          left: 0.875rem;
          top: 50%;
          transform: translateY(-50%);
          height: 1rem;
          width: 1rem;
          color: var(--icon);
          pointer-events: none;
        }

        .search-input {
          width: 100%;
          padding: 0.625rem 0.875rem 0.625rem 2.5rem;
          border-radius: 0.5rem;
          border: 1px solid var(--light-gray);
          font-size: 0.875rem;
          transition: all 0.2s ease;
          color: var(--text);
          background-color: var(--background);
          font-family:
            "Inter",
            -apple-system,
            BlinkMacSystemFont,
            "Segoe UI",
            Roboto,
            Oxygen,
            Ubuntu,
            sans-serif;
          font-weight: 400;
        }

        .search-input:focus {
          outline: none;
          border-color: var(--primary);
          background-color: var(--background);
          box-shadow: 0 0 0 3px rgba(255, 90, 0, 0.12);
        }

        .search-input:hover:not(:focus) {
          border-color: var(--secondary);
          background-color: var(--background);
        }

        .search-input::placeholder {
          color: var(--icon);
          font-weight: 400;
        }

        /* Remove default search input styling */
        .search-input::-webkit-search-cancel-button,
        .search-input::-webkit-search-decoration {
          -webkit-appearance: none;
          appearance: none;
        }

        /* Dark mode support */
        @media (prefers-color-scheme: dark) {

          .search-input:focus,
          .search-input:hover:not(:focus) {
            border-color: var(--primary);
          }

          .search-input::placeholder {
            color: var(--icon);
          }

          .search-icon {
            color: var(--icon);
          }
        }
      `}</style>
    </div>
  );
}

export default SearchBar;
